const GOOGLE_MAPS_API_KEY_LITERAL = 'AIzaSyC_IdMKsGMg-Vzb2OoLesNFZJQ9UuMuhpc';

export const GOOGLE_MAPS_API_KEY: string =
  (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) ||
  GOOGLE_MAPS_API_KEY_LITERAL ||
  '';

export const GOOGLE_MAPS_ENABLED: boolean = Boolean(GOOGLE_MAPS_API_KEY);
